import type { IconData } from '@stacksjs/iconify-core'

export const flickrSquare: IconData = {
  "body": "<g fill=\"currentColor\"><circle cx=\"7.364\" cy=\"10.379\" r=\"2.364\"/><circle cx=\"12.628\" cy=\"10.379\" r=\"2.364\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default flickrSquare
